import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'

const WhatsappConfirmationModal = ({ updateWhatsappOtpIn, isOpen , handleClose}) => {
    const handleConfirmBtn = () => {
        updateWhatsappOtpIn();
        handleClose();
    }

    return (
        <ReactModal
            className={'confirmation-modal'}
            overlayClassName={'confirmation-modal-overlay'}
            contentLabel= {'Delete Confirmation'}
            onRequestClose={handleClose}
            isOpen={isOpen}>

            <div className={'confirmation-modal-content'}>

                <div className={'confirmation-modal-header'}>
                    <button type={'button'} className={'close confirmation-modal-button'} style={{'paddingRight': '10px'}} onClick={handleClose} >&times;</button>
                    <div className={'confirmation-modal-title'}>
                        Change WhatsApp Opt-in
                    </div>
                </div>

                <div className={'confirmation-modal-body'}>
                    <div className={'confirmation-modal-text'}>
                        Are you sure you want to change the opt-in status for this patient?
                    </div>
                </div>

                <div className={'confirmation-modal-footer'}>
                    <button type={'button'} className={'btn btn-default'} style={{ 'marginRight': '10px'}} onClick={handleClose}>No</button>
                    <button type={'button'} className={'btn btn-danger'} onClick={handleConfirmBtn}>Yes</button>
                </div>
            </div>

        </ReactModal>
    )
}

WhatsappConfirmationModal.propTypes = {
    updateWhatsappOtpIn: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
}

export default WhatsappConfirmationModal



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/WhatsappConfirmationModal.js